import axios from 'axios';

const host = import.meta.env.VITE_APP_API_HOST;
const instance = axios.create({
  baseURL: import.meta.env.VITE_APP_API_BASE + host,
  headers: {
    'Content-Type': 'application/json',
    Accept: '*/*',
    'Access-Control-Allow-Origin': 'https://d2jx1u0gvnl03f.cloudfront.net',
  },
});

export default instance;